import { useAppDispatch } from '@/shared/hooks';

import { accessModel } from '@/entities/access';
import { patientModel } from '@/entities/patient';

export const useSetDoctors = () => {
  const dispatch = useAppDispatch();

  return async ({
    patientID,
    staffIDs,
  }: {
    patientID: string;
    staffIDs: string[];
  }) => {
    const { Patient } = await dispatch(
      accessModel.thunks.setPatientTeamMembers({
        PatientID: patientID,
        StaffIDs: staffIDs,
      }),
    ).unwrap();

    if (Patient) {
      dispatch(patientModel.actions.setNewestOne(Patient));
    }
  };
};
